/* eslint-disable no-undef */
const fontTheme = [
  {
    name: 'Large1_B',
    tw: 'font-large1-bold',
    theme: 'theme.fonts[font-large1-bold]',
    fontWeight: '700',
    fontSize: '24px',
    lineHeight: '30px',
  },
  {
    name: 'Large1_R',
    tw: 'font-large1',
    theme: 'theme.fonts[font-large1]',
    fontWeight: '400',
    fontSize: '24px',
    lineHeight: '30px',
  },
  {
    name: 'Large2_B',
    tw: 'font-large2-bold',
    theme: 'theme.fonts[font-large2-bold]',
    fontWeight: '700',
    fontSize: '22px',
    lineHeight: '28px',
  },
  {
    name: 'Large3_B',
    tw: 'font-large3-bold',
    theme: 'theme.fonts[font-large3-bold]',
    fontWeight: '700',
    fontSize: '21px',
    lineHeight: '26px',
  },
  {
    name: 'Large3_R',
    tw: 'font-large3',
    theme: 'theme.fonts[font-large3]',
    fontWeight: '400',
    fontSize: '21px',
    lineHeight: '26px',
  },
  {
    name: 'Large4_B',
    tw: 'font-large4-bold',
    theme: 'theme.fonts[font-large4-bold]',
    fontWeight: '700',
    fontSize: '20px',
    lineHeight: '24px',
  },
  {
    name: 'Large4_R',
    tw: 'font-large4',
    theme: 'theme.fonts[font-large4]',
    fontWeight: '400',
    fontSize: '20px',
    lineHeight: '24px',
  },
  {
    name: 'Medium1_alt_B',
    tw: 'font-medium1-alt-bold',
    theme: 'theme.fonts[font-medium1-alt-bold]',
    fontWeight: '700',
    fontSize: '16px',
    lineHeight: '20px',
  },
  {
    name: 'Medium1_B',
    tw: 'font-medium1-bold',
    theme: 'theme.fonts[font-medium1-bold]',
    fontWeight: '700',
    fontSize: '16px',
    lineHeight: '22px',
  },
  {
    name: 'Medium1_R',
    tw: 'font-medium1',
    theme: 'theme.fonts[font-medium1]',
    fontWeight: '400',
    fontSize: '16px',
    lineHeight: '22px',
  },
  {
    name: 'Medium2_alt_B',
    tw: 'font-medium2-alt-bold',
    theme: 'theme.fonts[font-medium2-alt-bold]',
    fontWeight: '700',
    fontSize: '14px',
    lineHeight: '18px',
  },
  {
    name: 'Medium2_B',
    tw: 'font-medium2-bold',
    theme: 'theme.fonts[font-medium2-bold]',
    fontWeight: '700',
    fontSize: '14px',
    lineHeight: '20px',
  },
  {
    name: 'Medium2_R',
    tw: 'font-medium2',
    theme: 'theme.fonts[font-medium2]',
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '20px',
  },
  {
    name: 'Small1_alt_B',
    tw: 'font-small1-alt-bold',
    theme: 'theme.fonts[font-small1-alt-bold]',
    fontWeight: '700',
    fontSize: '13px',
    lineHeight: '16px',
  },
  {
    name: 'Small1_B',
    tw: 'font-small1-bold',
    theme: 'theme.fonts[font-small1-bold]',
    fontWeight: '700',
    fontSize: '13px',
    lineHeight: '18px',
  },
  {
    name: 'Small1_R',
    tw: 'font-small1',
    theme: 'theme.fonts[font-small1]',
    fontWeight: '400',
    fontSize: '13px',
    lineHeight: '18px',
  },
  {
    name: 'Small2_B',
    tw: 'font-small2-bold',
    theme: 'theme.fonts[font-small2-bold]',
    fontWeight: '700',
    fontSize: '12px',
    lineHeight: '16px',
  },
  {
    name: 'Small2_R',
    tw: 'font-small2',
    theme: 'theme.fonts[font-small2]',
    fontWeight: '400',
    fontSize: '12px',
    lineHeight: '16px',
  },
  {
    name: 'Xsmall1_B',
    tw: 'font-x-small1-bold',
    theme: 'theme.fonts[font-x-small1-bold]',
    fontWeight: '700',
    fontSize: '11px',
    lineHeight: '16px',
  },
  {
    name: 'Xsmall1_R',
    tw: 'font-x-small1',
    theme: 'theme.fonts[font-x-small1]',
    fontWeight: '400',
    fontSize: '11px',
    lineHeight: '16px',
  },
  {
    name: 'Xsmall2_B',
    tw: 'font-x-small2-bold',
    theme: 'theme.fonts[font-x-small2-bold]',
    fontWeight: '700',
    fontSize: '10px',
    lineHeight: '16px',
  },
  {
    name: 'Xsmall2_R',
    tw: 'font-x-small2',
    theme: 'theme.fonts[font-x-small2]',
    fontWeight: '400',
    fontSize: '10px',
    lineHeight: '16px',
  },
];

exports.fontTheme = fontTheme;
